import {
  Snackbar,
  CircularProgress,
  Alert,
  SnackbarCloseReason,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useEffect } from "react";
import theme from "../../styles/styleTheme";

interface SavingDataSnackbarProps {
  open: boolean;
  loading: boolean;
  setOpen: any;
}

const SavingDataSnackbar = ({
  open,
  loading,
  setOpen,
}: SavingDataSnackbarProps) => {
  useEffect(() => {
    setOpen(true);
  }, [loading]);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
      <Alert
        icon={
          loading ? (
            <CircularProgress
              size={20}
              sx={{
                color: "#fff",
              }}
            />
          ) : (
            <CheckCircleIcon
              sx={{
                color: "#fff",
              }}
            />
          )
        }
        sx={{
          background: theme.palette.primary.main,
        }}
        variant="filled"
      >
        {loading ? "Opslaan" : "Opgeslagen"}
      </Alert>
    </Snackbar>
  );
};

export default SavingDataSnackbar;
